import * as React from "react";
function SvgUserTransmitter(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <circle
        cx={16}
        cy={10}
        r={7}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M11.11 29H5a11 11 0 0122 0h-6.11"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M30 15.26a14.79 14.79 0 000-10.52M2 4.74a14.79 14.79 0 000 10.52M26.29 13.86a10.85 10.85 0 000-7.72M5.71 6.14a10.85 10.85 0 000 7.72"
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserTransmitter);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
